import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { WebhookCreate, WebhookEventType } from '@/api/dashboard'
import { Button, Modal, ModalContent, ModalFooter, ModalProps, ModalTitle } from '@dashboard/ui'
import { SelectEventsList } from '@/layouts/webhooks/widgets/SelectEventsList'

interface SelectEventsStageModalProps extends ModalProps {
  onSubmitData: (data: WebhookCreate) => void
  events?: WebhookEventType[]
  currentWebhookId?: string
}

export const SelectEventsStageModal = (props: SelectEventsStageModalProps) => {
  const { ...rest } = props
  const { t } = useTranslation()
  const { control, handleSubmit } = useForm<WebhookCreate>({
    defaultValues: {
      events: props.events || [],
    },
  })

  const saveClick = async (data: WebhookCreate) => {
    props.onSubmitData(data)
    props.onClose?.()
  }

  return (
    <Modal {...rest} className="h-[780px]">
      <form onSubmit={handleSubmit(saveClick)} className="flex h-full flex-col">
        <ModalContent>
          <ModalTitle subtitle={t('webhook.form.select-events.stage.sub')}>
            {t('webhook.form.select-events.stage.title')}
          </ModalTitle>

          <Controller
            control={control}
            name="events"
            render={({ field }) => (
              <SelectEventsList
                value={field.value}
                currentWebhookId={props.currentWebhookId}
                onChange={v => field.onChange(v)}
              />
            )}
          />
        </ModalContent>

        <div className="mt-auto">
          <ModalFooter>
            <Button size="sm" onClick={props.onClose} color="secondary" variant="outline" type="button">
              {t('Cancel')}
            </Button>
            <Button size="sm" color="primary" type="submit">
              {t('apply')}
            </Button>
          </ModalFooter>
        </div>
      </form>
    </Modal>
  )
}
